import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/apiClient";
import { Logo } from "@/components/Logo";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full bg-transparent border border-white/25 px-4 py-3.5 text-white focus:border-[#D4FF00] focus:outline-none transition-colors placeholder:text-zinc-600";

  return (
    <div className="grain min-h-screen bg-[#050505] text-white flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Logo light className="mb-10" />
        <p className="font-mono-t text-xs uppercase tracking-[0.25em] text-[#D4FF00] mb-3">Admin Access</p>
        <h1 className="font-display text-4xl tracking-tight mb-10">Sign in to manage your site.</h1>
        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <input required type="email" data-testid="login-email" className={field} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input required type="password" data-testid="login-password" className={field} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          {error && <p className="text-[#FF3366] text-sm" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-[#D4FF00] text-black font-semibold py-3.5 hover:bg-[#BCE600] transition-colors disabled:opacity-50">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
